import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HcToastrService } from '@manager-app/service/toastr.service';
import { Subscription } from 'rxjs';
import { CountryModel, extractNumber, HxCountryService, HxSupplierService, HxUiLabelPipe, SupplierModel, toRouterQueryParams } from 'hx-services';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { SuppliersNewComponent } from '../suppliers-new/suppliers-new.component';
import { NgOptionComponent, NgSelectComponent } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { HxLoaderComponent } from 'hx-component';
import { NgbPagination } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-suppliers-list.m-grid__item.m-grid__item--fluid.m-wrapper',
    templateUrl: './suppliers-list.component.html',
    styleUrls: ['./suppliers-list.component.css'],
    imports: [SuppliersNewComponent, NgSelectComponent, FormsModule, NgFor, NgOptionComponent, NgIf, NgClass, HxLoaderComponent, NgbPagination, TranslocoPipe, HxUiLabelPipe]
})
export class SuppliersListComponent implements OnInit, OnDestroy {
  list: SupplierModel[] = [];
  pagination = {
    currentPage: 1,
    allItemCount: 0,
    limit: 20,
    maxPage: 1
  };
  isLoading = {
    list: false,
  };
  supplierId: number;
  categories = {};
  countries: CountryModel[] = [];
  params: {
    page?: number;
    limit?: number;
    countryId?: number;
    query?: string;
  } = {page: 1, limit: 20};
  private timeout: NodeJS.Timeout;
  private sub: Subscription;

  constructor(
    private supplierService: HxSupplierService,
    private aRoute: ActivatedRoute,
    private router: Router,
    private countryService: HxCountryService,
    private toastr: HcToastrService,
    private tr: TranslocoService
  ) {
  }

  ngOnInit() {
    this.loadCountries();
    this.sub = this.aRoute.queryParamMap.subscribe(paramMap => {
      this.params.page = extractNumber('page', paramMap) ?? 1;
      this.params.limit = extractNumber('limit', paramMap) ?? 20;
      this.params.query = paramMap.get('query');
      this.params.countryId = extractNumber('countryId', paramMap);

      this.loadList();
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  applyFilters() {
    this.pageChanged(1);
  }

  updater(event) {
    this.supplierId = null;
    if (event) {
      this.loadList();
    }
  }

  pageChanged(page: number) {
    this.params.page = page;
    this.navigateUrl();
  }

  updateItem(item) {
    this.supplierId = item.id;
  }

  deleteItem(id) {
    this.supplierService.removeSupplier(id).subscribe(() => {
      this.toastr.success(this.tr.translate('suppliers-list.ts.deleteSuccess'));
      this.loadList();
    }, err => {
      if (err && err.error && err.error.code === 574) {
        this.toastr.error(err.error.message);
      } else {
        this.toastr.error(this.tr.translate('suppliers-list.ts.error'));
      }
    });
  }

  onQueryChanged() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(() => {
      this.applyFilters();
    }, 800);
  }

  resetFilter() {
    this.pagination.allItemCount = 0;
    this.params = {page: 1, limit: 20};
    this.navigateUrl();
  }

  private loadList() {
    this.list = [];
    this.isLoading.list = true;

    this.supplierService.getSuppliers({page: this.params.page, query: this.params.query, countryIds: [this.params.countryId]}).subscribe(result => {
      this.list = result.list || [];
      this.isLoading.list = false;
      this.pagination.allItemCount = result.count;
    }, () => this.isLoading.list = false);
  }

  private navigateUrl() {
    this.router.navigate(['./'], {
      queryParams: toRouterQueryParams(this.params),
      relativeTo: this.aRoute
    });
  }

  private async loadCountries() {
    this.countries = await this.countryService.getCountries();
  }
}
